@if (floorPlan) {
  <svg class="zmv" [attr.viewBox]="'0 0 ' + viewW + ' ' + viewH" preserveAspectRatio="xMidYMid meet">
    <rect class="zmv-background" x="0" y="0" [attr.width]="viewW" [attr.height]="viewH"></rect>
    @if (imageUrl) { <image [attr.href]="imageUrl" x="0" y="0" [attr.width]="viewW" [attr.height]="viewH" [attr.preserveAspectRatio]="floorPlan.backgroundFit === 'fill' ? 'xMidYMid slice' : 'xMidYMid meet'"></image> }

    @for (element of elements; track element.id) {
      @if (element.type === 'line') {
        <polyline class="zmv-plan-line" [attr.points]="element.pointsAttr"></polyline>
      } @else {
        <text class="zmv-plan-label" [attr.x]="element.x" [attr.y]="element.y">{{ element.text }}</text>
      }
    }

    @for (s of shapes; track s.zoneId) {
      <g class="zmv-shape"
         [class.is-interactive]="interactive"
         [class.is-selected]="isSelected(s.zoneId)"
         [class.is-highlight]="highlightZoneId === s.zoneId"
         [attr.data-fill]="fillState(s.zoneId)"
         (click)="onClick(s.zoneId)">

        @if (s.type === 'rect') {
          <rect [attr.x]="s.x" [attr.y]="s.y" [attr.width]="s.w" [attr.height]="s.h"
                [attr.fill]="s.color" [attr.stroke]="s.color" rx="2" ry="2"></rect>
        } @else if (s.type === 'polygon') {
          <polygon [attr.points]="s.pointsAttr" [attr.fill]="s.color" [attr.stroke]="s.color"></polygon>
        } @else {
          <circle [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
                  [attr.fill]="s.color" stroke="#fff" [attr.stroke-width]="s.r * 0.25"></circle>
        }

        <text class="zmv-label" [attr.x]="s.labelX" [attr.y]="s.labelY"
              text-anchor="middle" dominant-baseline="middle">{{ s.name }}</text>

        @if (badge(s.zoneId)) {
          <text class="zmv-badge" [attr.x]="s.labelX" [attr.y]="s.labelY + 18"
                text-anchor="middle" dominant-baseline="middle">{{ badge(s.zoneId) }}</text>
        }
      </g>
    }
  </svg>
} @else {
  <div class="zmv-empty">No floor plan.</div>
}
